/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React TS Base Styles
import typography from '@/assets/md-theme-dark/base/typography';
import borders from 'src/assets/md-theme/base/borders';
import colors from 'src/assets/md-theme/base/colors';

// Material Dashboard 2 PRO React TS Helper Functions
import pxToRem from 'src/assets/md-theme/functions/pxToRem';

const { borderWidth } = borders;
const { light, text } = colors;
const { fontWeightMedium, size } = typography;

// types
type Types = any;

const tableHead: Types = {
  styleOverrides: {
    root: {
      display: 'table-header-group',
      '& th': {
        height: pxToRem(32), // h-8 equivalent
        padding: `0 ${pxToRem(8)}`, // px-2 equivalent
        textAlign: 'left',
        verticalAlign: 'middle',
        fontWeight: fontWeightMedium,
        color: text.main,
        fontSize: size.sm,
        whiteSpace: 'nowrap',
        textTransform: 'none', // Override any uppercase transformations
        '&:has([role=checkbox])': {
          paddingRight: 0,
        },
        '& [role=checkbox]': {
          transform: 'translateY(2px)',
        },
      },
      '& tr': {
        borderBottom: `${borderWidth[1]} solid ${light.main}`,
      },
    },
  },
};

export default tableHead;
